"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Retryable = Retryable;
//
// Copyright © 2025 Hardcore Engineering Inc.
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//
// See the License for the specific language governing permissions and
// limitations under the License.
//
const retry_1 = require("./retry");
/**
 * Method decorator for adding retry functionality to class methods
 *
 * @param options - Retry configuration options
 * @param operationName - Name of the operation for logging (defaults to method name)
 * @returns Method decorator
 */
function Retryable(options = retry_1.DEFAULT_RETRY_OPTIONS) {
    return function (target, propertyKey, descriptor) {
        const originalMethod = descriptor.value;
        descriptor.value = async function (...args) {
            const methodName = propertyKey.toString();
            return await (0, retry_1.withRetry)(() => originalMethod.apply(this, args), options, methodName);
        };
        return descriptor;
    };
}
//# sourceMappingURL=decorator.js.map